<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6 bg-gradient-success">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h3 class="card-title"><b-button size="sm" v-b-toggle.accordion-1 variant="info"><i class="fa fa-filter"></i></b-button>Filtros </h3>

          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <!--b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
              <b-card-text>{{ text }}</b-card-text>-->
              <b-row>
                <b-col sm="3">
                    <select name="tipo" v-on:change="onFiltroChange" v-model="filtro.tipo" id="tipo" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('tipo') }">
                        <option value="-1">Todos las Preguntas</option>
                        <option value="1">Faciles</option>
                        <option value="11">Dificiles</option>
                    </select>
                </b-col>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="Nivel">
                      <b-form-input size="sm" id="nivel" type="text" v-on:change="onFiltroChange" v-model="filtro.nivel" value="" placeholder="0"></b-form-input>
                    </b-input-group>
                    <!--<b-input-group size="sm" prepend="Documento">
                      <b-form-input size="sm" id="nroDocumento" type="text" v-on:change="onFiltroChange" v-model="filtro.nroDocumento" value="" placeholder="000"></b-form-input>
                    </b-input-group>-->
                </b-col>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="Premio">
                      <b-form-input size="sm" id="premio" type="text" v-on:change="onFiltroChange" v-model="filtro.premio" value="" placeholder="Premio"></b-form-input>
                    </b-input-group>                 </b-col>
                <b-col sm="3" class="text-center">
                        <b-button title="Aplicar filtro" :class="{'btn btn-success' :filtroActivo, 'btn btn-light':!filtroActivo}" @click="aplicarFiltro()"><i :class="{'fas fa-check':filtroActivo,'fas fa-ban':!filtroActivo}"></i></b-button>
                        <b-button title="Resetear filtro" variant="primary" @click="resetFiltro()"><i class="fas fa-undo"></i></b-button>
                </b-col>
              </b-row>
              <b-row>
                  <b-col sm="3">
                    <b-form-input class="form-control form-control-sm float-right" id="fechaI" type="date" v-on:change="onFiltroChange" v-model="filtro.fechaI" name="fechaI" min="01-01-2000"
              max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <b-form-input size="sm" id="fechaF" type="date" v-on:change="onFiltroChange" v-model="filtro.fechaF" name="fechaF" min="01-01-2000"
                max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <b-input-group size="sm" prepend="Cantidad">
                      <b-form-input size="sm" id="cant" type="text" v-on:change="onFiltroChange" v-model="filtro.cant" value="" placeholder="00000000"></b-form-input>
                    </b-input-group>
                  </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
        <b-card no-body>
              <b-card-header class="border-0">
                <h3 class="mb-0">Preguntas Quien Quiere Ser Millona<b class="millonario" >Rio</b></h3>
                    <div class="text-right">
                    <!--<base-button size="md"
                        body-class="text-left"
                        v-b-popover.hover.top="'Nuevo Nivel'"
                        type="success"
                        @click="newNivel()"
                        >
                        <i class="fas fa-save"></i>
                    </base-button>-->
                      <base-button size="md"
                        body-class="text-left"
                        v-b-popover.hover.top="'Configuración'"
                        type="primary"
                        @click="configGame()"
                        >
                        <b-icon icon="gear-fill" aria-hidden="true"></b-icon> Configuración
                      </base-button>
                    </div>
              </b-card-header>
            <div class="card-body table-responsive p-0">
                <table class="table table-hover text-center">
                  <tbody>
                    <tr>
                        <th v-show="$gate.isAuthor()">Id</th>
                        <th>Nivel</th>
                        <th><h4>Cant. de Preguntas: <b-badge variant="info">{{TotalPreguntas}}</b-badge></h4></th>
                        <th>Premio</th>
                        <th>Registrado el</th>
                        <th>Actualizado el</th>
                        <th>Acciones</th>
                  </tr>
                  <tr v-for="question in questions" :key="question.id">
                    <td v-show="$gate.isAuthor()">{{question.id}}</td>
                    <td>{{question.nivel}}</td>
                    <td><b-badge variant="success"><h5>-- {{procesarCantQ(question)}} --</h5></b-badge></td>
                    <td>
                      <div class="text-center">
                        <b-button size="md" variant="ligth" @click="verPremios(question)">
                          Ver premios <b-badge :variant="question.premio.productoPremio.length>0?'success':'danger'">{{question.premio.productoPremio.length}}</b-badge>
                        </b-button>
                      </div>
                    </td>
                    <td>{{question.created_at | myDate}}</td>
                    <td>{{question.updated_at | myDate}}</td>
                    <td>
                        <b-btn size="sm" href="#" @click="editModal(question)" variant="ligth">
                            <i class="fa fa-edit"></i>
                        </b-btn>

                        <b-btn size="sm" href="#" @click="deleteQqm(question.id)" variant="danger">
                            <i class="fa fa-trash"></i>
                        </b-btn>

                    </td>
                  </tr>
                </tbody></table>
                <!-- /.card -->
            </div>
            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination @change="getResults"  v-model="currentPage" :per-page="perPage" :total="totalItemsRow"></base-pagination>
            </b-card-footer>
        </b-card>
          <!--<light-table/>
          <dark-table/>-->
        </b-col>
      </b-row>
      <div class="mt-5"></div>
    </b-container>

    <!-- Modal Configuracion -->
  <b-modal id="modal-configuracion" ref="modal-configuracion" size="lg" title="Configuración" hide-footer>
    <b-form @submit.prevent="updateConfig()">
      <b-form-group>
      <b-row><!-- -->
        <b-col md="6">
          <label>Preguntas Especiales:   </label>
        </b-col>
        <b-col md="6">
          <b-form-checkbox v-model="configuracion[0].valor" name="check-button" button>
            <b>{{ configuracion[0].valor | ActInc}}</b>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <b-row><!-- -->
        <b-col md="6">
          <label>Tiempo (Seg) Máximo por Pregunta:   </label>
        </b-col>
        <b-col md="3">
          <base-input type="number" placeholder="" v-model="configuracion[1].valor" required></base-input>
        </b-col>
      </b-row>
      <b-row><!-- Respuestas -->
        <b-col md="6">
          <!--<base-input label="Cantidad" type="number" placeholder="" v-model="premioSelected.cantidad" required></base-input>-->
        </b-col>
      </b-row>
      <div class="modal-footer">
        <b-button size="sm" type="button" class="btn btn-danger" @click="hideModalConfig" >Cerrar</b-button>
        <b-button size="sm" v-show="editmodePremio" type="submit" class="btn btn-success">Actualizar</b-button>
        <b-button size="sm" v-show="!editmodePremio" type="submit" class="btn btn-primary">Guardar</b-button>
      </div>
      </b-form-group>
    </b-form>

  </b-modal>
<!-- end Modal-->


<!-- Modal Premios -->
       <b-modal id="modalPremio" ref="modalPremio" size="xl"  hide-footer>
        <template #modal-title>
            <h2 class="modal-title" v-show="!editmodePremio" id="addPremioLabel">Agregar Premios</h2>
            <h2 class="modal-title" v-show="editmodePremio" id="addPremioLabelAct">Actualizar Premios</h2>
        </template>
          <form @submit.prevent="editmodePremio ? updateCaja() : createCaja()">
            <b-row><!--Detalle de Arqueo-->
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Nivel:
                    <b-badge variant="primary">{{nivelSelected.nivel}}</b-badge>
                      <!--<b-form-input class="form-control" :disabled="deshabilitadoFecha" size="sm" v-model="filtro.fecha" type="date" value="2021-01-04" id="fecha"></b-form-input>-->
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col xl="3" md="6">
                    <div class="text-right">
                      <base-button size="md"
                          body-class="text-left"
                          v-b-popover.hover.top="'Nuevo Premio'"
                          type="success"
                          @click="newPremio()"
                          >
                          <i class="fas fa-save"></i>
                      </base-button>
                    </div>
              </b-col>
            </b-row>
            <hr class="my-3">
            <b-row>
              <b-col xl="12" md="12">
                <b-card no-body>
                  <table class="table table-striped the-table" >
                    <tr>
                      <th>Id</th>
                      <th class="mitdrespuesta">Descripcion</th>
                      <th class="mitdrc">Cantidad</th>
                      <th>Editar</th>
                    </tr>
                    <tr v-for="premio in form.premio.productoPremio" :key="premio.id">
                      <td class="mitdpregunta">{{premio.id}}</td>
                      <td>{{premio.descripcion}}</td>
                      <td><b>{{premio.cantidad}}</b></td>
                      <td>
                        <b-button v-b-modal.modal-premio @click="procesarPremio(premio)"  size="sm"><b-icon icon="pencil-square"></b-icon> </b-button>
                        <b-button variant="danger"  @click="eliminarePremio(premio)"  size="sm"><b-icon icon="trash-fill"></b-icon> </b-button>
                      </td>
                    </tr>
                  </table>
                </b-card>
              </b-col>
            </b-row>
          </form>
    </b-modal>

    <!-- Editar Premio -->
  <b-modal id="modal-premio" ref="modal-premio" size="lg" :title="'Premio - Nivel: '+nivelSelected.nivel" hide-footer>
    <form @submit.prevent="editmodePremio ? updatePremio() : createPremio()">
      <b-row><!-- -->
        <b-col md="12">
          <base-input label="Código" placeholder="" required v-model="premioSelected.id"></base-input>
        </b-col>
      </b-row>
      <b-row><!-- -->
        <b-col md="12">
          <base-input label="Descripción" placeholder="" required v-model="premioSelected.descripcion"></base-input>
        </b-col>
      </b-row>
      <b-row><!-- Respuestas -->
        <b-col md="6">
          <base-input label="Cantidad" type="number" placeholder="" v-model="premioSelected.cantidad" required></base-input>
        </b-col>
      </b-row>
      <div class="modal-footer">
        <b-button size="sm" type="button" class="btn btn-danger" @click="hideModalPremio" >Cerrar</b-button>
        <b-button size="sm" v-show="editmodePremio" type="submit" class="btn btn-success">Actualizar</b-button>
        <b-button size="sm" v-show="!editmodePremio" type="submit" class="btn btn-primary">Guardar</b-button>
      </div>
    </form>

  </b-modal>
<!-- end Modal-->

<!-- Modal  -->
       <b-modal id="modalNivelPreguntas" ref="modalNivelPreguntas" size="xl"  hide-footer>
        <template #modal-title>
            <h2 class="modal-title" v-show="!editmode" id="addNewLabel">Nuevo Nivel</h2>
            <h2 class="modal-title" v-show="editmode" id="addNewLabel">Actualizar Nivel</h2>
        </template>
          <form @submit.prevent="editmode ? updateCaja() : createCaja()">
            <b-row><!--Detalle de Arqueo-->
              <b-col xl="3" md="6">
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center">
                    Nivel Seleccionado:
                    <b-badge variant="primary">{{nivelSelected.nivel}}</b-badge>
                      <!--<b-form-input class="form-control" :disabled="deshabilitadoFecha" size="sm" v-model="filtro.fecha" type="date" value="2021-01-04" id="fecha"></b-form-input>-->
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col xl="3" md="6">
                  <div class="text-right">
                    <base-button size="md"
                        body-class="text-left"
                        v-b-popover.hover.top="'Nueva Pregunta'"
                        type="success"
                        @click="newQuestion()"
                        >
                        <i class="fas fa-save"></i>
                    </base-button>
                  </div>
              </b-col>
            </b-row>
            <hr class="my-3">
            <b-row>
              <b-col xl="12" md="12">
                <b-card no-body>
                  <table class="table the-table" >
                    <tr>
                      <th class="mithpregunta">Preguntas</th>
                      <th class="mitdrespuesta">Respuestas</th>
                      <th class="mitdrc">Correcta</th>
                      <th>Editar</th>
                    </tr>
                    <tr v-for="question in form.qqmForm.questions" :key="question.id">
                      <td class="mitdpregunta">{{question.p}}</td>
                      <td class="mitdpregunta"><b-badge :variant="question.rc==0?'success':'danger'" >{{question.rs[0]}}</b-badge>, <b-badge :variant="question.rc==1?'success':'danger'" >{{question.rs[1]}}</b-badge>, <b-badge :variant="question.rc==2?'success':'danger'">{{question.rs[2]}}</b-badge>, <b-badge :variant="question.rc==3?'success':'danger'">{{question.rs[3]}}</b-badge></td>
                      <td><b>{{respuestas[question.rc]}}</b></td>
                      <td>
                        <b-button v-b-modal.modal-multi-3 @click="procesarQuestion(question)"  size="sm"><b-icon icon="arrow-repeat"></b-icon> </b-button>
                      </td>
                    </tr>
                  </table>
                </b-card>
              </b-col>
            </b-row>
          </form>
    </b-modal>

    <!-- Editar Pregunta -->
  <b-modal id="modal-multi-3" ref="modal-multi-3" size="lg" :title="'Pregunta - Nivel: '+nivelSelected.nivel" hide-footer>
    <form @submit.prevent="editmodeQuestion ? updatePregunta() : createPregunta()">
      <b-row><!-- -->
        <b-col md="12">
          <base-input label="Pregunta" placeholder="" required v-model="questionSelected.p"></base-input>
        </b-col>
      </b-row>
      <hr class="my-3">
      <b-row><!-- Respuestas -->
        <b-col md="3">
          <base-input label="Respuesta A" placeholder="" v-model="questionSelected.rs[0]" required></base-input>
        </b-col>
        <b-col md="3">
          <base-input label="Respuesta B" placeholder="" v-model="questionSelected.rs[1]" required></base-input>
        </b-col>
        <b-col md="3">
          <base-input label="Respuesta C" placeholder="" v-model="questionSelected.rs[2]" required></base-input>
        </b-col>
        <b-col md="3">
          <base-input label="Respuesta D" placeholder="" v-model="questionSelected.rs[3]" required></base-input>
        </b-col>
      </b-row>
      <b-row> <!-- Respuesta Correcta-->
        <b-col md="4">
          <b-select id="selecrc" v-model="questionSelected.rc" name="selecrc" required>
            <option :value="-1">Respuesta Correcta</option>
            <option :value="0">A</option>
            <option :value="1">B</option>
            <option :value="2">C</option>
            <option :value="3">D</option>
          </b-select>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <b-form-checkbox
            id="checkbox-1"
            v-model="questionSelected.pe"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
          >
            Es Pregunta Especial
          </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="modal-footer">
        <b-button size="sm" type="button" class="btn btn-danger" @click="hideModalPregunta" >Cerrar</b-button>
        <b-button size="sm" v-show="editmodeQuestion" type="submit" class="btn btn-success">Actualizar</b-button>
        <b-button size="sm" v-show="!editmodeQuestion" type="submit" class="btn btn-primary">Guardar</b-button>
      </div>
    </form>
    <!--<p class="my-1">Los turnos Ya fueron Procesados</p>-->

  </b-modal>
<!-- end Modal-->

  </div>
</template>

<script>
 import { Dropdown, DropdownItem, DropdownMenu, Form, Table, TableColumn } from 'element-ui';

  export default {
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
            return {
                editmode: false,
                editmodeQuestion:false,
                editmodePremio:false,
                filtroActivo:false,
                perPage:10,
                currentPage: 1,
                totalItemsRow:10,
                respuestas:['A','B','C','D'],
                questionSelected:{
                        av:false,
                        p:"",
                        pe:false,
                        rc:-1,
                        rs:['','','','']
                      },
                nivelSelected:{},
                premioSelected:{},
                configuracion:[{id:0, valor:0}, {id:1, valor:0}],
                questions : [],
                loteQuestios: {
                    id: 0,
                    nivel: 0,
                    created_at: '',
                    updated_at: '',
                    qqForm: {
                      questions:[{
                        av:false,
                        p:"",
                        pe:false,
                        rc:-1,
                        rs:['','','','']
                      }]
                    }
                },
                form: new Form({
                    id: 0,
                    nivel: 0,
                    created_at: '',
                    updated_at: '',
                    qqmForm: {
                      questions:[{
                        av:false,
                        p:"",
                        pe:false,
                        rc:-1,
                        rs:['','','','']
                      }]
                    },
                    premio:{
                      productoPremio:[
                      ]
                    }
                }),
                filtro: new Form({
                    cant: '',
                    premio: '',
                    nivel:'',
                    idTurno: -1,
                    Caja: 0,
                    fechaI: this.getDate(),
                    fechaF: this.getDate(),
                    monto: 0,
                    tipo: "-1",
                    estatus:"1"
                }),
            }
        },
        methods: {
            async getResults(page = 1) {
                await axios.get(this.$gate.getApiUrl()+'Qqm/SendQuestions?page='+page+'&perPage='+this.perPage+'&Tipo='+this.filtro.tipo,{ params: this.filtro })
                .then(({ data }) => {
                this.questions = data;
                //this.questions.preguntaRespuesta.question = JSON.parse(this.questions.preguntaRespuesta);
                this.totalItemsRow = data.totalrow;
                }).catch( e => {
                    /* si el token es invalido o esta vencido */
                    if (e.response.status == 401) {
                    this.$gate.removeLogin();
                    this.$router.push("/Login");
                    }
                });
            },
            configGame(){

              this.$refs['modal-configuracion'].show();
            },
            procesarCantQ(question){
                if (question.qqmForm != null) {
                  return question.qqmForm.questions.length;
                }else{
                  return 0;
                }
            },
            createPregunta(){//agrega una Nueva pregunta
              if(this.questionSelected.rc > -1){
                  this.nivelSelected.qqmForm.questions.push(this.questionSelected);

                  this.form.fill(this.nivelSelected);//= this.nivelSelected;//
                  this.updateQqm();
                  this.hideModalPregunta();
              }else{
                this.$swal(
                  '',
                  'Seleccione la Respuesta correcta',
                  'error'
                )
              }
            },
            updatePregunta(){//actualiza  una pregunta
              if(this.questionSelected.rc > -1){
                this.updateQqm();
                this.hideModalPregunta();
              }else{
                this.$swal(
                  '',
                  'Seleccione la Respuesta correcta',
                  'error'
                )
              }
            },
            newQuestion(){
              //console.log("newQuestion");
              this.editmodeQuestion = false;
              this.questionSelected = {
                      av:false,
                      p:"",
                      pe:false,
                      rc:-1,
                      rs:['','','','']
                    };
              this.$refs['modal-multi-3'].show();
            },
            editModal(question){
                this.editmode = true;
                if(question.qqmForm == null){
                  question.qqmForm = { questions: [] };
                }

                // -- nivel Seleccionado;
                this.nivelSelected = question;
                this.form.reset();
                this.form.fill(question);
                this.$refs['modalNivelPreguntas'].show();
            },
            newPremio(){
              this.nivelSelected.premio.productoPremio.push({ cantidad:0, descripcion:'', id: (this.nivelSelected.premio.productoPremio.length+1) });
              this.editmodePremio = premio.productoPremio?false:true;

              if(premio.qqmForm == null){
                premio.qqmForm = { questions: [] };
              }

              //this.nivelSelected = premio;
              this.premioSelected = this.nivelSelected.premio.productoPremio[this.nivelSelected.premio.productoPremio.length-1];
              this.form.reset();
              this.form.fill(this.nivelSelected);
              this.$refs['modal-premio'].show();
            },
            procesarPremio(premio){
              this.premioSelected = premio;
            },
            deletePremio(idPremio){
              let arr = this.form.premio.productoPremio;
              for( var i = 0; i < arr.length; i++){

                  if ( arr[i].id === idPremio) {

                      arr.splice(i, 1);
                  }

              }
            },
            eliminarePremio(premio){
              console.log(this.form)
                this.$swal({
                    title: 'Esta Seguro de Eliminar: '+premio.descripcion+'?',
                    text: "No podra revertir los cambios!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, Procedo a Borrar!'
                    }).then((result) => {

                        // Send request to the server
                         if (result.value) {
                                this.deletePremio(premio.id);
                                this.updatePremio();
                                /*this.form.delete(this.$gate.getApiUrl()+'Qqm/'+id).then(()=>{
                                        this.$swal(
                                        'Eliminado!',
                                        'Premio Borrado.',
                                        'success'
                                        )
                                    Fire.$emit('AfterCreate');
                                }).catch(()=> {
                                    this.$swal("Failed!", "There was something wronge.", "warning");
                                });*/
                         }
                    })
            },
            newNivel(){
                /*this.editmode = false;
                this.form.reset();
                this.form.nivel = this.questions.length;
                //this.nivelSelected = this.questions
                //console.log(this.form)
                //this.form.qqForm.questions = [];
                if( this.form.nivel <= 15){
                  //this.nivelSelected.nivel = this.form.nivel+1;
                  this.form.nivel  = this.form.nivel+1;
                  this.$refs['modalNivelPreguntas'].show();
                }else{
                  this.$swal(
                    '',
                    'Ya ha completado todos los niveles del juego',
                    'error'
                  )
                }*/

            },
            aplicarFiltro(){
                //if(this.$gate.isAdmin()){
                let loader = this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,
                    canCancel: true,
                    loader: 'dots',
                });
                this.getResults();
                loader.hide();
            },
            resetFiltro(){
                this.filtro.reset();
                this.filtroActivo = false;
                this.getResults();
            },
            onFiltroChange(){
                this.filtroActivo = true;
            },
            verPremios(premio){
              this.editmodePremio = premio.productoPremio?false:true;

              if(premio.qqmForm == null){
                premio.qqmForm = { questions: [] };
              }

              this.nivelSelected = premio;
              this.form.reset();
              this.form.fill(premio);
              this.$refs['modalPremio'].show();
            },
            hideModalConfig(){
              this.$refs['modal-configuracion'].hide();
            },
            hideModalPremio() {
                this.$refs['modal-premio'].hide();
            },
            hideModalPregunta() {
                this.$refs['modal-multi-3'].hide();
            },
            hideModal() {
                this.$refs['modalNivelPreguntas'].hide();
            },
            procesarQuestion(question){
              this.editmodeQuestion = true;
              this.questionSelected = question;
            },
            createQqm(){
                this.form.post(this.$gate.getApiUrl()+'Qqm/SaveQuestions', this.form)
                .then(() => {
                    // success
                    this.$swal({
                    title: 'Pregunta Creada Exitosamente!!',
                    icon: 'success',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end',
                    timer: 3000
                    })
                    Fire.$emit('AfterCreate');
                    this.hideModal();
                //this.$Progress.finish();
                })
                .catch((e) => {
                if (e.response.status == 400) {
                    this.$swal(
                        '',
                        e.response.data.message,
                        'error'
                    )
                }
                //this.$Progress.fail();
                });

            },
            updateQqm(){
                this.form.put(this.$gate.getApiUrl()+'Qqm/SaveQuestions/'+this.nivelSelected.id)
                .then(() => {
                    // success
                    //this.$refs['modal-1'].hide();
                    this.$swal({
                    title: 'Pregunta Agregada',
                    icon: 'success',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end',
                    timer: 3000
                    })
                    Fire.$emit('AfterCreate');
                //this.$Progress.finish();
                })
                .catch((e) => {
                //console.log(e)
                //this.$Progress.fail();
                });
                //this.hideModal();
            },
            deleteQqm(id){
                this.$swal({
                    title: 'Esta Seguro de Eliminar todas las Preguntas?',
                    text: "No podra revertir los cambios!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, Procedo a Borrar!'
                    }).then((result) => {

                        // Send request to the server
                         if (result.value) {
                                this.form.delete(this.$gate.getApiUrl()+'Qqm/'+id).then(()=>{
                                        this.$swal(
                                        'Eliminado!',
                                        'Registro Borrado.',
                                        'success'
                                        )
                                    Fire.$emit('AfterCreate');
                                }).catch(()=> {
                                    this.$swal("Failed!", "There was something wronge.", "warning");
                                });
                         }
                    })
            },
            updatePremio(){
                this.form.put(this.$gate.getApiUrl()+'Qqm/SaveGifts/'+this.nivelSelected.id)
                .then(() => {
                    // success
                    //this.$refs['modal-1'].hide();
                    this.$swal({
                    title: 'Premio Actualizado',
                    icon: 'success',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end',
                    timer: 3000
                    })
                    Fire.$emit('AfterCreate');
                //this.$Progress.finish();
                })
                .catch((e) => {
                //console.log(e)
                //this.$Progress.fail();
                });
              this.hideModalPremio();
            },
            createPremio(){

            },
            updateConfig(){
                this.configuracion[0].valor = this.configuracion[0].valor?1:0;
                axios.post(this.$gate.getApiUrl()+'Qqm/SaveConfig', this.configuracion)
                .then(() => {
                    // success
                    //this.$refs['modalNivelPreguntas'].hide();

                    this.$swal({
                    title: 'Configuración Actualizada Exitosamente!!',
                    icon: 'success',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end',
                    timer: 3000
                    })
                    Fire.$emit('AfterCreate');
                    this.hideModalConfig();
                //this.$Progress.finish();
                })
                .catch((e) => {
                if (e.response.status == 400) {
                    this.$swal(
                        '',
                        e.response.data.message,
                        'error'
                    )
                }

                //this.$Progress.fail();
                });
            },
            getDate(){
                var currentDate = new Date();
                return currentDate.getFullYear()+"-"+(currentDate.getMonth()<9?"0"+(currentDate.getMonth()+1):(currentDate.getMonth()+1))+"-"+(currentDate.getDate()<10?"0"+currentDate.getDate():currentDate.getDate());
            },
            loadQqm(){
              if(this.$gate.isUserAdminOrMer()){
                  this.getResults();
              }
              axios.get(this.$gate.getApiUrl()+"Qqm/GetConfig").then(({ data }) => {this.configuracion = data; this.configuracion[0].valor = this.configuracion[0].valor==1?true:false;});
            }
        },
        created() {
           this.loadQqm();
           Fire.$on('AfterCreate',() => {
               this.loadQqm();
           });
        //    setInterval(() => this.loadQqm(), 3000);
        },
        mounted(){
            //axios.get("/api/agencia").then(({ data }) => this.agencias = data.data);
            //axios.get("/api/typequestions/"+this.$gate.idUser()).then(({ data }) => this.typequestions = data);
        },
        computed: {
          TotalPreguntas: function(){
            let total = [];

            Object.entries(this.questions).forEach(([key, val]) => {
                total.push(val.qqmForm.questions.length) // the value of the current key.
            });

            return total.reduce(function(total, num){ return total + num }, 0);

          }
        }
    }
</script>
<style>
.the-table { table-layout: fixed; width: 100%; }
.mithpregunta{
  width: 40%;
  overflow: auto;
}
.mitdpregunta{
  overflow: auto;
}
.mitdrespuesta{
  width: 40%;
  /*overflow: auto;*/
}
.mitdrc{
  width: 10%;
  /*overflow: auto;*/
  text-align: center;
}
.millonario{
  color: green;
}
</style>
